import NoticeModal from '#src/components/NoticeModal';

import styles from './styles.module.scss';

/**
 *
 * @param {object} props
 * @param {boolean} props.visible
 * @param {() => void} props.onClose
 * @param {string} props.className,
 * @param {string} props.ctaClassName,
 * @param {string} props.theme
 * @returns {JSX.Element}
 */
export function NudgeModal(props) {
  return (
    <NoticeModal
      className={styles.modalDialog}
      ctaClassName={styles.cta}
      content={{ title: "Let's make it happen!", ctaLabel: 'See my plan' }}
      {...props}
    >
      <div className={styles.modalContent}>
        Thanks to your awesome answers, we&#x27;ve created a weight loss game
        plan just for you. Don&#x27;t close this page or your info could be
        lost.
      </div>
    </NoticeModal>
  );
}
